import React from "react";
import classNames from "classnames";
import styles from "./CustomerInformation.module.scss";

export function RequestDetails({ partnerName, initiatedBy, expanded = false }) {

    const cardHeaderClasses = classNames({
        "card-header": true,
        [styles.cardHeader]: true
    });

    const cardBodyClasses = expanded ?  classNames({
        "collapse show": true,
        [styles.cardBody]: true
    }) : classNames({
        "collapse": true,
        [styles.cardBody]: true
    });

    return (
        <div className="card card-collapse">
            <div className={cardHeaderClasses}>
                <a
                    data-toggle="collapse"
                    aria-expanded={expanded}
                    href="#collapseRequestDetails"
                >
                    <div className={styles.header}>
                        Request details
                        <span>
                            <i className="material-icons">keyboard_arrow_down</i>
                        </span>
                    </div>
                </a>
            </div>
            <div id="collapseRequestDetails" className={cardBodyClasses}>
                <div className={styles.info}>
                    <span className="material-icons-outlined">compare_arrows</span>
                    Requested by {initiatedBy}
                </div>
                <div className={styles.info}>
                    <span className="material-icons-outlined">language</span>
                    Initiated through {partnerName}
                </div>
            </div>
        </div>
    )
}
